import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5b9b1096"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center textDark--text mb-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mew-heading-2 provider-text" }, "Select a provider to buy", -1))
const _hoisted_3 = { class: "mew-heading-2 mb-10" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "best-rate"
}
const _hoisted_6 = { class: "d-flex mew-heading-3" }
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = { class: "mew-heading-3 pl-1 mr-1" }
const _hoisted_9 = { class: "elevated-box pa-3 textDark--text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "d-flex align-center justify-space-between mt-3" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "d-flex flex-column align-center mb-1" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { class: "mew-label d-none d-sm-block" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-2 text-center mew-label" }, " Fees, availability, and purchase limits vary between providers, you can check their quotes and select one that works for you. ", -1))

import { computed, inject } from "vue";

import visaLogo from "@/assets/images/icon-visa.svg";
import mastercardLogo from "@/assets/images/icon-master.svg";
import bankLogo from "@/assets/images/icon-bank.svg";
import applePayLogo from "@/assets/images/icon-apple-pay.svg";
import paypalLogo from "@/assets/images/icon-paypal-logo.svg";
import googlePayLogo from "@/assets/images/icon-google-pay-logo.svg";
import pixLogo from "@/assets/images/icon-pix-logo.svg";

import { storeToRefs } from "pinia";
import { useGlobalStore } from "@/plugins/globalStore";
import { currencySymbols } from "./handler/prices";

import { BuyProviders } from "./types";


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyProviders',
  setup(__props) {

const amplitude: any = inject("$amplitude");

const store = useGlobalStore();
const { buyProviders, selectedFiat, selectedCrypto, selectedNetwork } =
  storeToRefs(store);

const amount = computed(() => {
  return buyProviders.value.length > 0 ? buyProviders.value[0].fiat_amount : 0;
});

const formattedFiat = computed(() => {
  const symbol = currencySymbols[selectedFiat.value.name]
    ? currencySymbols[selectedFiat.value.name]
    : "";
  return `${symbol}${amount.value}`;
});

const isEUR = computed(() => {
  return selectedFiat.value.name === "EUR" || selectedFiat.value.name === "GBP";
});

const generateFeeLabel = (provider: BuyProviders) => {
  const feeLabel: { [key: string]: string } = {
    MOONPAY: `Includes ${isEUR.value ? 0.7 : 4.99}% fee`,
    SIMPLEX: "Includes fee 5.25% fee",
    TOPPER: "Includes 4.65% fee. First transaction is free.",
    COINBASE: "Includes 2.5% fee.",
  };

  return feeLabel[provider.provider];
};

const generateLimits = (provider: string, daily = true) => {
  const dailyLimits: { [key: string]: string } = {
    MOONPAY: "Daily limit: $10,000",
    SIMPLEX: "Daily limit: $20,000",
    TOPPER: "Daily limit: $20,000",
    COINBASE: "Daily limit: $20,000",
  };

  const monthlyLimits: { [key: string]: string } = {
    MOONPAY: "Monthly limit: $50,000",
    SIMPLEX: "Monthly limit: $50,000",
    TOPPER: "Monthly limit: $50,000",
    COINBASE: "Monthly limit: $50,000",
  };

  return daily ? dailyLimits[provider] : monthlyLimits[provider];
};

const parseProviderLogo = (provider: BuyProviders) => {
  const providerLogos: { [key: string]: any } = {
    SIMPLEX: require("@/assets/images/icon-simplex.png"),
    MOONPAY: require("@/assets/images/icon-moonpay.svg"),
    TOPPER: require("@/assets/images/icon-topper.svg"),
    COINBASE: require("@/assets/images/icon-coinbase-light.webp"),
  };
  return providerLogos[provider.provider];
};

const parsePaymentMethods = (
  paymentMethods: Array<string>,
  label = false
): Array<string> | string => {
  const logos: Array<string> = [];
  let paymentMethodsLabel = "";
  if (
    paymentMethods.includes("CREDIT_CARD") ||
    paymentMethods.includes("DEBIT_CARD") ||
    paymentMethods.includes("CARD")
  ) {
    logos.push(visaLogo);
    logos.push(mastercardLogo);
    paymentMethodsLabel += "Visa, Mastercard";
  }

  if (
    (paymentMethods.includes("ACH") ||
      paymentMethods.includes("ACH_BANK_ACCOUNT") ||
      paymentMethods.includes("SEPA_OPEN_BANKING")) &&
    isEUR.value
  ) {
    logos.push(bankLogo);
    paymentMethodsLabel += `${
      paymentMethodsLabel.length > 0 ? ", " : ""
    }Bank account`;
  }

  if (paymentMethods.includes("PAYPAL")) {
    logos.push(paypalLogo);
    paymentMethodsLabel += `${
      paymentMethodsLabel.length > 0 ? ", " : ""
    }Paypal`;
  }

  if (paymentMethods.includes("APPLE_PAY")) {
    logos.push(applePayLogo);
    paymentMethodsLabel += `${
      paymentMethodsLabel.length > 0 ? ", " : ""
    }Apple Pay`;
  }

  if (paymentMethods.includes("GOOGLE_PAY")) {
    logos.push(googlePayLogo);
    paymentMethodsLabel += `${
      paymentMethodsLabel.length > 0 ? ", " : ""
    }Google Pay`;
  }

  if (paymentMethods.includes("PIX")) {
    logos.push(pixLogo);
    paymentMethodsLabel += `${paymentMethodsLabel.length > 0 ? ", " : ""}Pix`;
  }

  return label ? paymentMethodsLabel : logos;
};

const buy = (provider: BuyProviders) => {
  window.open(provider.url, "_blank");
  if (provider.provider === "SIMPLEX") {
    amplitude.track(`CCBuySellBuyWithSimplex`);
  } else if (provider.provider === "MOONPAY") {
    amplitude.track(`CCBuySellBuyWithMoonpay`);
  } else if (provider.provider === "TOPPER") {
    amplitude.track(`CCBuySellBuyWithTopper`);
  } else if (provider.provider === "COINBASE") {
    amplitude.track(`CCBuySellBuyWithCoinbase`);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_icon, {
        color: "textDark",
        class: "cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" mdi-arrow-left mr-4 ")
        ]),
        _: 1
      }),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, " Spending " + _toDisplayString(formattedFiat.value) + " to buy " + _toDisplayString(_unref(selectedCrypto).symbol) + " on " + _toDisplayString(_unref(selectedNetwork).name_long) + " Network ", 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(buyProviders), (provider, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: provider.provider + idx,
        class: "section-block ripple pa-5 mb-6",
        onClick: ($event: any) => (buy(provider))
      }, [
        (idx === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Best Rate"))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(provider.crypto_amount) + " ", 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(provider.crypto_currency), 1),
              _createVNode(_component_v_tooltip, {
                location: "bottom",
                "min-width": "200px"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_icon, _mergeProps({ ref_for: true }, props, {
                    color: "grey-lighten-1",
                    size: "x-small",
                    class: "cursor-pointer"
                  }), {
                    default: _withCtx(() => [
                      _createTextVNode(" mdi-information ")
                    ]),
                    _: 2
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(_toDisplayString(generateFeeLabel(provider)) + " ", 1),
                    _hoisted_10,
                    _hoisted_11,
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(generateLimits(provider.provider)) + " ", 1),
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(generateLimits(provider.provider, false)), 1)
                  ])
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              src: parseProviderLogo(provider),
              alt: provider.provider + ' logo',
              width: "100"
            }, null, 8, _hoisted_15),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                class: _normalizeClass([
                'd-flex align-center mb-1 justify-end',
                _ctx.$vuetify.display.mdAndDown ? 'flex-wrap' : '',
              ]),
                style: _normalizeStyle(
                _ctx.$vuetify.display.mdAndDown ? 'width : 150px;' : 'width: 100%'
              )
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsePaymentMethods(
                  provider.payment_methods
                ), (logo, idx) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: idx + logo,
                    src: logo,
                    alt: provider.provider + ' payment method',
                    width: "40",
                    class: "mr-1"
                  }, null, 8, _hoisted_17))
                }), 128))
              ], 6),
              _createElementVNode("div", _hoisted_18, _toDisplayString(parsePaymentMethods(provider.payment_methods, true)), 1)
            ])
          ])
        ])
      ], 8, _hoisted_4))
    }), 128)),
    _hoisted_19
  ]))
}
}

})